var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1528_26012",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1528_26012)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.05391 10.8362L11.5359 6.35416L10.8334 5.65161L7.05391 9.43109L5.15391 7.53109L4.45136 8.23364L7.05391 10.8362ZM8.00118 14.3336C7.12523 14.3336 6.30187 14.1674 5.53111 13.835C4.76035 13.5025 4.08989 13.0513 3.51975 12.4815C2.94959 11.9116 2.49822 11.2414 2.16563 10.471C1.83304 9.70056 1.66675 8.87738 1.66675 8.00143C1.66675 7.12547 1.83297 6.30211 2.16541 5.53136C2.49786 4.76059 2.94903 4.09014 3.51891 3.51999C4.08881 2.94984 4.75898 2.49846 5.5294 2.16588C6.29981 1.83329 7.12299 1.66699 7.99895 1.66699C8.8749 1.66699 9.69826 1.83321 10.469 2.16566C11.2398 2.4981 11.9102 2.94927 12.4804 3.51916C13.0505 4.08906 13.5019 4.75922 13.8345 5.52964C14.1671 6.30005 14.3334 7.12324 14.3334 7.99919C14.3334 8.87515 14.1672 9.6985 13.8347 10.4693C13.5023 11.24 13.0511 11.9105 12.4812 12.4806C11.9113 13.0508 11.2412 13.5022 10.4707 13.8347C9.70032 14.1673 8.87714 14.3336 8.00118 14.3336Z",
    fill: "#018897"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckedIcon);
export default __webpack_public_path__ + "static/media/checked-icon.9598837e56a83719b2ba95177d80c3cf.svg";
export { ForwardRef as ReactComponent };